import React from "react";
import { Button, SxProps, Theme } from "@mui/material";

type ButtonVariant = "primary" | "primary-alt" | "secondary";

interface CtaButtonProps {
  label: string;
  onClick: () => void;
  variant?: ButtonVariant;
  disabled?: boolean;
  width?: string | number;
  height?: string | number;
  icon?: React.ReactNode;
}

const getButtonStyles = (
  variant: ButtonVariant,
  disabled: boolean,
  width?: string | number,
  height?: string | number
): SxProps<Theme> => {
  const baseStyles = {
    width: width || "366px",
    height: height || "56px",
    borderRadius: "28px",
    fontFamily: '"Roboto Condensed", sans-serif',
    fontSize: "24px",
    textAlign: "center",
    lineHeight: "normal",
    textTransform: "none",
    transition: "all 0.2s ease",
    cursor: disabled ? "not-allowed" : "pointer",
  };

  switch (variant) {
    case "primary":
      return {
        ...baseStyles,
        backgroundColor: disabled ? "#ECECEC" : "#F7B500",
        color: disabled ? "#595959" : "#000",
        border: "none",
        fontWeight: 700,
        boxShadow: disabled ? "none" : "0px 4px 4px rgba(229, 229, 229, 0.25)",
      };

    case "primary-alt":
      return {
        ...baseStyles,
        backgroundColor: "white",
        color: disabled ? "#595959" : "#000",
        border: `2px solid ${disabled ? "#ECECEC" : "#F7B500"}`,
        fontWeight: 700,
        boxShadow: "none",
      };

    case "secondary":
      return {
        ...baseStyles,
        backgroundColor: "transparent",
        color: disabled ? "#595959" : "#000",
        border: "none",
        fontWeight: 400,
        boxShadow: "none",
      };
  }
};

export const CtaButton = ({
  label,
  onClick,
  variant = "primary",
  disabled = false,
  width,
  height,
  icon,
}: CtaButtonProps) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      sx={getButtonStyles(variant, disabled, width, height)}
      startIcon={icon}
    >
      {label}
    </Button>
  );
};
